import { render } from "./SharperVision.vue?vue&type=template&id=49ade9ba&scoped=true"
import script from "./SharperVision.vue?vue&type=script&lang=js"
export * from "./SharperVision.vue?vue&type=script&lang=js"

import "./SharperVision.vue?vue&type=style&index=0&id=49ade9ba&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ade9ba"]])

export default __exports__